export const STATEMENT_DISABLED = process.env.VUE_APP_STATEMENT_DISABLED === 'true'
export const STATEMENT_DISABLED_MESSAGE = process.env.VUE_APP_STATEMENT_DISABLED_MESSAGE
export const OPEN_NRS_URI = process.env.VUE_APP_OPEN_NRS_URI
